export default "__VITE_ASSET__DRRGc9rO__"